import { useState } from "react";

import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { PremiumFeatureContactUsModal } from "app/pages/sales-intelligence/pages/premium-features/components/PremiumFeatureContactUsModal/PremiumFeatureContactUsModal";
import premiumFeatureTrackingService from "app/pages/sales-intelligence/services/tracking/premium-feature/trackingService";
import { openHooksModalV5 } from "app/services/ModalService";
import { isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

import {
    StyledHeaderButton,
    StyledHeaderContainer,
    StyledHeaderDescription,
    StyledHeaderImage,
    StyledHeaderTitle,
    StyledHeaderWrapper,
    StyledMainContent,
} from "./styles";

export const PremiumFeatureHeader = () => {
    const [contactUsModal, setContactUsModal] = useState<boolean>(false);
    const isNT = isNoTouch(swSettings);

    const handleContactUsClick = () => {
        premiumFeatureTrackingService.trackPremiumFeatureAction("Header");
        if (isNT) {
            openHooksModalV5("ContactUs", undefined, "Premium features", "GetLoading");
        } else {
            setContactUsModal(true);
            requestFeature("PremiumHeader");
        }
    };

    return (
        <StyledHeaderContainer>
            <StyledHeaderWrapper>
                <StyledMainContent>
                    <StyledHeaderTitle>{translate("si.premium-feature.header.title")}</StyledHeaderTitle>
                    <StyledHeaderDescription>
                        {translate("si.premium-feature.header.description")}
                    </StyledHeaderDescription>
                    <StyledHeaderButton
                        type="trial"
                        iconName="sparkles"
                        onClick={handleContactUsClick}
                    >
                        {translate("si.common.contact_us")}
                    </StyledHeaderButton>
                </StyledMainContent>
                <StyledHeaderImage />
            </StyledHeaderWrapper>
            <PremiumFeatureContactUsModal
                isOpen={contactUsModal}
                onClose={() => setContactUsModal(false)}
            />
        </StyledHeaderContainer>
    );
};
